
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/london/seo-design-portfolio/digital-marketing-for-health-and-wellness",
      function () {
        return require("private-next-pages/london/seo-design-portfolio/digital-marketing-for-health-and-wellness/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/london/seo-design-portfolio/digital-marketing-for-health-and-wellness"])
      });
    }
  